<template>
  <div id="messages" class="page-shell">
    <el-breadcrumb v-if="isPathMessageList" separator-class="el-icon-arrow-right" class="page-breadcrumb">
      <el-breadcrumb-item :to="{ name: 'Dashboard' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>Messages</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="page-header">
      <h1 class="page-title">Messages</h1>
      <div class="page-actions">
        <el-button v-if="isPathMessageList" type="primary" icon="el-icon-refresh" @click="getList()">Refresh</el-button>
        <el-button type="danger" plain icon="el-icon-document" @click="exportPdf">Export PDF</el-button>
        <el-button type="success" plain icon="el-icon-document-checked" @click="exportExcel">Export Excel</el-button>
      </div>
    </div>

    <div class="messages-page__stats">
      <div class="messages-stat">
        <div class="messages-stat__label">Visible</div>
        <div class="messages-stat__value">{{ filteredItems.length }}</div>
      </div>
      <div class="messages-stat">
        <div class="messages-stat__label">OK</div>
        <div class="messages-stat__value">{{ statusCount("ok") }}</div>
      </div>
      <div class="messages-stat">
        <div class="messages-stat__label">Pending</div>
        <div class="messages-stat__value">{{ statusCount("pending") }}</div>
      </div>
      <div class="messages-stat">
        <div class="messages-stat__label">Stop</div>
        <div class="messages-stat__value">{{ statusCount("stop") }}</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :title="infoModal.title" width="640px" @closed="resetModal">
      <form-custom
        v-if="infoModal.title"
        title="Message Editor"
        :schema="schema"
        :model="item"
        @commit="saveObject"
        @revert="resetModal"
      >
      </form-custom>
    </el-dialog>
  </div>
</template>

<script>
import Utils from "../utils";
import Swal from "sweetalert2";
import moment from "moment-timezone";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

var _ = require("lodash");
var XLSX = require("xlsx");

export default {
  data: function () {
    return {
      loading: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: {
        text: "",
        sender_id: "",
        receiver_id: "",
        states: ["ok", "pending", "stop"],
        dateTime: "America/Caracas",
      },
      stateMap: {
        ok: [
          "msg_send_start",
          "msg_receive_start",
          "mdn_send_start",
          "mdn_receive_start",
          "msg_sent_mdn_received_ok",
          "msg_rxd_mdn_sent_ok",
          "msg_rxd_mdn_not_requested_ok",
          "msg_sent_mdn_received_mic_mismatch",
        ],
        pending: [
          "msg_send_exception",
          "msg_receive_exception",
          "mdn_sending_exception",
          "mdn_receiving_exception",
        ],
        stop: [
          "msg_send_fail",
          "msg_send_fail_resend_queued",
          "msg_receive_fail",
          "msg_rxd_asyn_mdn_send_fail_resend_queued",
          "mdn_asyn_receive_fail",
          "msg_rxd_mdn_sending_fail",
          "msg_receive_error_sending_mdn_error",
          "msg_sent_mdn_received_error",
        ],
      },
      filterField: {
        locations: [
          {
            name: "sender_id",
            label: "Local station",
            list: [{ value: "", text: "All" }],
          },
          {
            name: "receiver_id",
            label: "Remote station",
            list: [{ value: "", text: "All" }],
          },
        ],
        states: [
          { text: "OK", value: "ok" },
          { text: "Pending", value: "pending" },
          { text: "Stop", value: "stop" },
        ],
        dateTimes: [
          {
            text: "Local [America/Caracas; -04:00]",
            value: "America/Caracas",
          },
          {
            text: "AS2 Server [Europe/Berlin; +02:00]",
            value: "Europe/Berlin",
          },
        ],
      },
      emptyStateMessage: "",
      items: [],
      dialogVisible: false,

      item: {
        _id: null,
        name: "",
        as2_id: "",
        email: "",
        x509_alias: "",
      },
    };
  },
  computed: {
    filteredItems() {
      let list = this.items.slice();

      if (this.filter.text) {
        const needle = this.filter.text.toLowerCase();
        list = list.filter((item) =>
          [
            item.msg_id,
            item.file_name,
            item.sender_id,
            item.receiver_id,
            item.encryption_algorithm,
            item.signature_algorithm,
            item.mdn_mode,
          ]
            .join(" ")
            .toLowerCase()
            .includes(needle)
        );
      }

      if (this.filter.sender_id) {
        list = list.filter((item) => item.sender_id === this.filter.sender_id);
      }

      if (this.filter.receiver_id) {
        list = list.filter((item) => item.receiver_id === this.filter.receiver_id);
      }

      if (!this.filter.states.length) {
        return [];
      }

      return list.filter((item) => {
        return this.filter.states.some((group) =>
          this.stateMap[group].includes(item.state)
        );
      });
    },
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredItems.slice(start, start + this.perPage);
    },
  },
  watch: {
    filteredItems() {
      const maxPage = Math.max(1, Math.ceil(this.filteredItems.length / this.perPage));
      if (this.currentPage > maxPage) {
        this.currentPage = maxPage;
      }
    },
    perPage() {
      this.currentPage = 1;
    },
    "filter.text"() {
      this.currentPage = 1;
    },
    "filter.sender_id"() {
      this.currentPage = 1;
    },
    "filter.receiver_id"() {
      this.currentPage = 1;
    },
    "filter.states"() {
      this.currentPage = 1;
    },
  },
  mounted: async function () {
    await this.getList();
    await this.getListPartners();
  },
  methods: {
    statusAppearance(state) {
      if (this.stateMap.ok.includes(state)) {
        return { label: "OK", type: "success" };
      }
      if (this.stateMap.pending.includes(state)) {
        return { label: "Pending", type: "warning" };
      }
      if (this.stateMap.stop.includes(state)) {
        return { label: "Stop", type: "danger" };
      }
      return { label: state || "Unknown", type: "info" };
    },
    statusCount(group) {
      return this.filteredItems.filter((item) =>
        this.stateMap[group].includes(item.state)
      ).length;
    },
    formatTimestamp(value) {
      if (!value) {
        return "-";
      }
      return moment.tz(value, this.filter.dateTime).utc().format("YYYY-DD-MM H:mm:ss");
    },
    exportExcel() {
      const fileName = "table-" + moment().format("YYYYMMDDH:mm:ss") + ".xlsx";
      const rows = this.filteredItems.map((item, index) => ({
        "#": index + 1,
        State: this.statusAppearance(item.state).label,
        Timestamp: this.formatTimestamp(item.create_dt),
        Sender: item.sender_id,
        Receiver: item.receiver_id,
        MessageID: item.msg_id,
        Payload: item.file_name,
        Encryption: item.encryption_algorithm,
        Signature: item.signature_algorithm,
        MDN: item.mdn_mode,
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "messages");
      XLSX.writeFile(wb, fileName);
    },
    exportPdf() {
      const doc = new jsPDF({ orientation: "landscape" });
      const body = this.filteredItems.map((item, index) => ({
        idx: index + 1,
        state: this.statusAppearance(item.state).label,
        create_dt: this.formatTimestamp(item.create_dt),
        sender_id: item.sender_id,
        receiver_id: item.receiver_id,
        msg_id: item.msg_id,
        file_name: item.file_name,
        encryption_algorithm: item.encryption_algorithm,
        signature_algorithm: item.signature_algorithm,
        mdn_mode: item.mdn_mode,
      }));

      autoTable(doc, {
        columns: [
          { header: "#", dataKey: "idx" },
          { header: "State", dataKey: "state" },
          { header: "Timestamp", dataKey: "create_dt" },
          { header: "Local", dataKey: "sender_id" },
          { header: "Remote", dataKey: "receiver_id" },
          { header: "Message ID", dataKey: "msg_id" },
          { header: "Payload", dataKey: "file_name" },
          { header: "Encryption", dataKey: "encryption_algorithm" },
          { header: "Signature", dataKey: "signature_algorithm" },
          { header: "MDN", dataKey: "mdn_mode" },
        ],
        body,
      });
      doc.save("table-" + moment().format("YYYYMMDDH:mm:ss") + ".pdf");
    },
    resetModal: function () {
      this.infoModal.title = "";
      this.item = {
        _id: null,
        name: "",
        as2_id: "",
        email: "",
        x509_alias: "",
      };
      this.dialogVisible = false;
    },
    deleteObject: async function (item) {
      try {
        const results = await Utils.Crud.getList("messages");
        if (
          !Array.isArray(results) ||
          results.length === 0 ||
          typeof results[0] === "string"
        ) {
          this.emptyStateMessage =
            results && results.length
              ? results[0]
              : "No message tracking data available yet.";
          this.items = [];
          return;
        }
        this.items = _.map(results, (item, index) => ({
          key: index,
          id: item.ID,
          state: item.STATE,
          create_dt: item.CREATE_DT,
          sender_id: item.SENDER_ID,
          receiver_id: item.RECEIVER_ID,
          msg_id: item.MSG_ID,
          file_name: item.FILE_NAME,
          encryption_algorithm: item.ENCRYPTION_ALGORITHM || "Unknown",
          signature_algorithm: item.SIGNATURE_ALGORITHM || "Unknown",
          mdn_mode: item.MDN_MODE,
        }));
      } catch (e) {
        this.items = [];
        this.emptyStateMessage = "Unable to load message data.";
        Swal.fire("Error!", e, "error");
      } finally {
        this.loading = false;
      }
    },
    newObject: function () {
      this.infoModal.title = "New partner";
      this.item = {
        _id: null,
        name: "",
        as2_id: "",
        email: "",
        x509_alias: "",
      };
      this.dialogVisible = true;
    },
    editObject: async function (_item) {
      this.infoModal.title = "Message Edit";
      var newObj = this.getNewObject();
      const result = await Utils.Crud.getObject("partner", _item.key, newObj);
      this.item = Object.assign(this.item, result);
      this.dialogVisible = true;
    },
    showObject: async function (_item) {
      this.$router.push({
        name: "MessageDetail",
        params: { id: _item.key },
        query: { msgId: _item.msg_id, source: "messages" },
      });
    },
    getNewObject: function () {
      var obj = { _id: null };
      this.schema.fields.forEach((f) => (obj[f.name] = f.value));
      return obj;
    },
    getField: function (item, key) {
      if (!item || typeof item !== "object") {
        return null;
      }

      const lowerKey = key.toLowerCase();
      const value = item[key];
      const lowerValue = item[lowerKey];

      if (value !== undefined && value !== null && value !== "") return value;
      if (lowerValue !== undefined && lowerValue !== null && lowerValue !== "") return lowerValue;
      return null;
    },
    mapMessageItem: function (item, index) {
      return {
        key: index,
        id: this.getField(item, "ID"),
        state: this.getField(item, "STATE"),
        create_dt: this.getField(item, "CREATE_DT"),
        sender_id: this.getField(item, "SENDER_ID"),
        receiver_id: this.getField(item, "RECEIVER_ID"),
        msg_id: this.getField(item, "MSG_ID"),
        file_name: this.getField(item, "FILE_NAME"),
        encryption_algorithm: this.getField(item, "ENCRYPTION_ALGORITHM")
          ? this.getField(item, "ENCRYPTION_ALGORITHM")
          : "Unknown",
        signature_algorithm: this.getField(item, "SIGNATURE_ALGORITHM")
          ? this.getField(item, "SIGNATURE_ALGORITHM")
          : "Unknown",
        mdn_mode: this.getField(item, "MDN_MODE"),
        prior_msg_id: this.getField(item, "PRIOR_MSG_ID") || "",
        is_resend: this.getField(item, "IS_RESEND") === "Y",
        resend_count: this.getField(item, "RESEND_COUNT") || "0",
        status: this.getField(item, "STATUS") || "-",
      };
    },
    resolveRootMessageId: function (item, byMessageId) {
      let current = item;
      const visited = new Set();

      while (current && current.prior_msg_id && byMessageId[current.prior_msg_id] && !visited.has(current.prior_msg_id)) {
        visited.add(current.prior_msg_id);
        current = byMessageId[current.prior_msg_id];
      }

      return current && current.msg_id ? current.msg_id : item.msg_id;
    },
    collapseRetryChains: function (items) {
      const byMessageId = {};
      items.forEach((item) => {
        if (item.msg_id) {
          byMessageId[item.msg_id] = item;
        }
      });

      const groups = new Map();
      items.forEach((item) => {
        const rootMessageId = this.resolveRootMessageId(item, byMessageId);
        if (!groups.has(rootMessageId)) {
          groups.set(rootMessageId, []);
        }
        groups.get(rootMessageId).push(item);
      });

      return Array.from(groups.values()).map((group) => {
        const orderedGroup = group.slice().sort((left, right) => {
          return String(left.create_dt || "").localeCompare(String(right.create_dt || ""));
        });
        const root = orderedGroup.find((item) => !item.prior_msg_id) || orderedGroup[0];
        const latest = orderedGroup[orderedGroup.length - 1];
        return {
          ...root,
          state: latest.state,
          status: latest.status,
          resend_count: String(Math.max(0, orderedGroup.length - 1)),
          attempts: orderedGroup,
        };
      });
    },
    getList: async function () {
      this.items = await Utils.Crud.getList("messages").then((results) => {
        console.log("results", results);
        const mappedItems = _.map(results, (item, index) => this.mapMessageItem(item, index));
        return this.collapseRetryChains(mappedItems);
      });
    },
    getListPartners: async function () {
      let list = _.map(await Utils.Crud.getList("partner"), (item) => {
        return { value: item, text: item };
      });
      let _list = _.concat(this.filterField.locations[0].list, list);

      this.filterField.locations[0].list = _list;
      this.filterField.locations[1].list = _list;
    },
    saveObject: async function (data) {
      try {
        await Utils.Crud.saveObject("partner", data);
        this.resetModal();
        await this.getList();
      } catch (e) {
        Swal.fire("Error!", e, "error");
      }
    },
  },
};
</script>
<style >
</style>
